import React from 'react';

const Content = ({ post }) => {
  return (
    <div
      className="font-normal max-w-3xl mx-1 md:mx-36 px-4 py-6 text-lg text-gray-700 leading-[1.75] prose"
      dangerouslySetInnerHTML={{ __html: post.content }}
    />
  );
};

export default Content;
